import { useCallback } from 'react'

export const useInstructions = () => {
  const navigateToDocumentation = useCallback(() => {
    window.open('https://docs.sequencehq.com/connectors/overview', '_blank')
  }, [])

  return {
    documentation: {
      onClick: navigateToDocumentation
    }
  }
}
